import type { ReactNode } from 'react';

import { cn } from '@/utils/cn.ts';

/**
 * Shared wrapper for all chat message rows.
 * Provides consistent width, spacing, and horizontal alignment.
 */
export const MessageRow = ({
	justify = 'start',
	children,
	className,
	'data-testid': dataTestId,
}: {
	justify?: 'start' | 'end';
	children: ReactNode;
	className?: string;
	'data-testid'?: string;
}) => (
	<div
		className={cn(
			'my-2 flex w-full max-w-[900px]',
			justify === 'end' ? 'justify-end' : 'justify-start',
			className,
		)}
		data-testid={dataTestId}
	>
		{children}
	</div>
);
